import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
    clearSelectedScheduleAction,
    scheduleState,
    setSelectedScheduleAction,
} from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import {Schedule} from "../../types/schedule/schedule";
import {DashboardDeliveryGroupCard} from "../card/DashboardDeliveryGroupCard";
import {LineNameCard} from "../card/LineNameCard";

interface Props {
    displaySchedule: Schedule;
    dashboardScheduleLineType?: "ScheduleCheck" | "Dashboard";
}

export const DashboardScheduleLine: React.FC<Props> = (
    {
        displaySchedule,
        dashboardScheduleLineType,
    }
) => {
    const dispatch = useAppDispatch();
    const {selectedSchedule} = useAppSelector(scheduleState);
    const onClickDashboardHeader = () => {
        if (displaySchedule.id === selectedSchedule?.id) {
            dispatch(clearSelectedScheduleAction());
            return;
        }
        dispatch(setSelectedScheduleAction({selectedSchedule: displaySchedule}));
    };

    return (
        <DashboardScheduleLineContainer>
            <DashboardScheduleLineHeader
                isSelected={displaySchedule.id === selectedSchedule?.id}
                onClick={onClickDashboardHeader}
            >
                <LineNameCard displaySchedule={displaySchedule}/>
            </DashboardScheduleLineHeader>

            <DashboardDeliveryGroupCardContainer
                isSelected={displaySchedule.id === selectedSchedule?.id}
                scrollable={dashboardScheduleLineType === "ScheduleCheck"}
                theme={theme}
            >
                {displaySchedule.deliveryGroups.map(
                    (deliveryGroup, deliveryGroupIndex) => (
                        <DashboardDeliveryGroupCard
                            deliveryGroup={deliveryGroup}
                            deliveryGroupIndex={deliveryGroupIndex}
                            schedule={displaySchedule}
                        />
                    )
                )}
            </DashboardDeliveryGroupCardContainer>
        </DashboardScheduleLineContainer>
    );
};

const DashboardScheduleLineContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

interface DashboardScheduleLineHeader {
    isSelected: boolean;
}

const DashboardScheduleLineHeader = styled.div<DashboardScheduleLineHeader>`
  display: flex;
  align-items: center;
  width: 169px;
  height: 149px;
  box-sizing: border-box;
  background: white;
`;

interface DashboardDeliveryGroupCardContainerProps {
    scrollable: boolean;
    isSelected: boolean;
    theme: any;
}

const DashboardDeliveryGroupCardContainer = styled.div<DashboardDeliveryGroupCardContainerProps>`
  overflow-x: scroll;
  width: ${(props) =>
          !props.scrollable ? "calc(73vw - 184px)" : "calc(100vw - 297px)"};
  padding-right: ${(props) => (props.scrollable ? "1vw" : "2vw")};
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 12px;
  align-items: center;
  height: 149px;
  box-sizing: border-box;

  background: ${(props: DashboardDeliveryGroupCardContainerProps) =>
          props.isSelected
                  ? props.theme.palette.primitives["yellow100"]
                  : props.theme.palette.primitives["gray50"]};

  white-space: nowrap;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${theme.palette.primitives.gray100};
  }

  scrollbar-width: thin;

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${theme.palette.primitives.gray400};
  }

  & > div:last-child > div {
    border-right: none;
  }
`;
